import script from "./QpupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QpupPage.vue?vue&type=script&setup=true&lang=js"

import "./QpupPage.vue?vue&type=style&index=0&id=76c24f24&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c24f24"]])

export default __exports__